'use client';
import type { AvatarProps } from '@mui/material/Avatar';

import { useQuery } from '@apollo/client/react';

import { Skeleton } from '@mui/material';

import { graphql } from '@/gql';

import { UserAvatar } from './UserAvatar';

const USER_IMAGE_QUERY = graphql(`
  query UserImage($userId: ID!) {
    user(id: $userId) {
      ...userImageFields
    }
  }
`);

interface Props extends AvatarProps {
  userId: string | null | undefined;
  size: number;
}

export const UserAvatarWithQuery = ({ userId, size, sx, ...other }: Props) => {
  const userIdForQuery = userId ?? '';
  const { loading, data } = useQuery(USER_IMAGE_QUERY, {
    variables: { userId: userIdForQuery },
    skip: !userId,
  });

  if (loading && !data) {
    return <Skeleton variant="circular" height={size} width={size} />;
  }

  return (
    <UserAvatar user={data?.user ?? null} size={size} sx={sx} {...other} />
  );
};
